import { render, staticRenderFns } from "./ViewMessageLogPage.vue?vue&type=template&id=5becfec1&scoped=true"
import script from "./ViewMessageLogPage.vue?vue&type=script&lang=js"
export * from "./ViewMessageLogPage.vue?vue&type=script&lang=js"
import style0 from "./ViewMessageLogPage.vue?vue&type=style&index=0&id=5becfec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becfec1",
  null
  
)

export default component.exports